import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

// project imports

import AuthCardWrapper from '../AuthCardWrapper';
import AuthRegister from './auth-forms/AuthRegister';
import { useState } from 'react';
import JWTOtpVerification from './auth-forms/otpVerification';
import RegisterSuccess from './auth-forms/registerSuccess';
// import RegisterSuccess from './auth-forms/registerSuccess';
type LoginType = 'email' | 'phone';
// type Registerlables = 'Sign up' | 'Otp verification' | 'Success';
type RegisterStep = 'signup' | 'verification' | 'registerSuccess';

interface RegisterStepInfo {
    title: string;
    subTitle: string;
    emailsubTitle: string;
    phonesubTitle: string;
    data: any;
}

interface RegisterObj {
    [key: string]: RegisterStepInfo;
}

const registerObj: RegisterObj = {
    signup: {
        title: 'Registration',
        subTitle: '',
        emailsubTitle: '',
        phonesubTitle: '',
        data: ''
    },
    verification: {
        title: 'Otp verification',
        subTitle: '',
        emailsubTitle: `Enter Otp to verify your email `,
        phonesubTitle: `Enter Otp to verify your mobile `,
        data: ''
    },
    registerSuccess: {
        title: '',
        subTitle: '',
        emailsubTitle: '',
        phonesubTitle: '',
        data: ''
    }
};

// assets

// ===============================|| AUTH3 - REGISTER ||=============================== //

interface SignUpTabs {
    theme: Theme;
}

const SignUpTabs = styled(Tabs)(({ theme }: SignUpTabs) => ({
    '.MuiTab-root': {
        padding: '.3125rem .625rem',
        minHeight: '32px',
        // background:'#d4e8e1',
        // backgroundColor: alpha(theme.palette.secondary.main, 0.9),
        backgroundColor: theme.palette.dark.dark,

        // color: '#212121',
        color: theme.palette.text.dark,
        marginRight: '1px',
        fontSize: '0.875rem',
        width: 'calc(50% - 1px)',
        fontWeight: '700'
    },
    '.Mui-selected': {
        padding: '.3125rem .625rem',

        backgroundColor: alpha(theme.palette.secondary.main, 1),
        minHeight: '32px',
        color: '#fff !important',
        fontSize: '0.875rem',
        width: '100%',
        fontWeight: '700',
        maxWidth: '100% !important'
    },
    '.MuiTabs-indicator': {
        display: 'none'
    }
}));

const Register = ({ forceOpen }: { forceOpen: Function }) => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const [activeTab, setActiveTab] = useState<LoginType>('phone');
    const [registerStep, setRegisterStep] = useState<RegisterStep>('signup');

    // Function to get data for the current step
    const getCurrentStepData = (): RegisterStepInfo => {
        return registerObj[registerStep];
    };

    // Handler function to update the step
    const handleStepChange = (newStep: RegisterStep) => {
        
        setRegisterStep(newStep);
    };

    const getRegisterData = (newdata: any) => {
        return (registerObj[registerStep].data = newdata);
    };
    // Call getCurrentStepData whenever the registerStep changes
    const currentStepData = getCurrentStepData();

    const handleChange = (event: React.SyntheticEvent, newValue: LoginType) => {
        setActiveTab(newValue);
    };

    console.log('registerObj', registerObj);
    return (
        <Grid container direction="column" justifyContent="flex-end" className="343434" sx={{ backgroundColor: '#050505' }}>
            <Grid item xs={12}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item sx={{ margin: '0px' }} className="2222222">
                        <AuthCardWrapper>
                            <Grid
                                item
                                container
                                alignItems="center"
                                justifyContent="center"
                                sx={{ backgroundColor: '#050505', margin: '0px' }}
                            >
                                <Grid item sx={{ margin: '0px' }} xs={12}>
                                    <Grid
                                        container
                                        direction={matchDownSM ? 'column-reverse' : 'row'}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item>
                                            <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                <Typography
                                                    // color={theme.palette.secondary.main}
                                                    gutterBottom
                                                    variant={matchDownSM ? 'h3' : 'h1'}
                                                    sx={{
                                                        // color: '#212121',
                                                        color: theme.palette.secondary.main,
                                                        // marginBottom: '1.5625rem !important',
                                                        textTransform: 'uppercase',
                                                        fontSize: '1.25rem',
                                                        fontWeight: '700',
                                                        lineHeight: '1.5625rem ',
                                                        marginBottom: '15px !important'
                                                    }}
                                                >
                                                    {currentStepData.title}
                                                </Typography>
                                                <Grid item>
                                                    {currentStepData.title && (
                                                        <Typography
                                                            variant="caption"
                                                            fontSize="16px"
                                                            textAlign={matchDownSM ? 'center' : 'inherit'}
                                                            sx={{ color: theme.palette.secondary.main }}
                                                        >
                                                            {activeTab === 'email'
                                                                ? currentStepData.emailsubTitle
                                                                : currentStepData.phonesubTitle}
                                                        </Typography>
                                                    )}
                                                    {registerStep === 'registerSuccess' && <RegisterSuccess forceOpen={forceOpen} />}
                                                </Grid>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid item sx={{ display: registerStep === 'signup' ? 'block' : 'none', padding: '0px' }}>
                                        <AuthRegister
                                            loginMode={activeTab}
                                            currentStepData={currentStepData}
                                            handleStepChange={handleStepChange}
                                            getRegisterData={getRegisterData}
                                        />
                                    </Grid>
                                    <Grid item sx={{ display: registerStep === 'verification' ? 'block' : 'none' }}>
                                        <JWTOtpVerification
                                            loginMode={activeTab}
                                            currentStepData={currentStepData}
                                            handleStepChange={handleStepChange}
                                            registerObj={registerObj}
                                        />
                                    </Grid>
                                </Grid>
                                {registerStep !== 'registerSuccess' && (
                                    <>
                                        <Grid item xs={12} sx={{ padding: '15px 0px 25px 0px' }}>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid item container direction="column" alignItems="center" xs={12}>
                                                <Button
                                                    onClick={() => forceOpen('login')}
                                                    sx={{
                                                        background: 'none',
                                                        color: theme.palette.secondary.main,
                                                        fontSize: '0.875rem',
                                                        fontWeight: '700',
                                                        border: '1px solid ',
                                                        textTransform: 'none',
                                                        borderColor: theme.palette.secondary.main,
                                                        width: '100%',
                                                        ':hover': {
                                                            background: 'none'
                                                        }
                                                    }}
                                                >
                                                    {' '}
                                                    Already have an account?
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </AuthCardWrapper>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Register;
